import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { resetPassword } from "src/api/auth";
import { showSuccessToast } from "src/lib/utils";
import PasswordInput from "src/components/widgets/PasswordInput";

const validationSchema = Yup.object().shape({
	token: Yup.string().required("Token is required"),
	password: Yup.string().min(8, "Password must be at least 8 characters").required("Password is required"),
	password_confirmation: Yup.string()
		.oneOf([Yup.ref("password"), null], "Passwords must match")
		.required("Confirm password is required"),
});

const ResetPassword = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const token = searchParams.get("token");

	useEffect(() => {
		if (!token) {
			navigate("/login");
		}
	}, [token, navigate]);

	const initialValues = {
		token: "",
		password: "",
		password_confirmation: "",
	};

	const { mutate, isLoading } = useMutation(resetPassword, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			navigate("/login");
		},
	});

	return (
		<div className="loginForm tw-px-6 md:tw-px-10 tw-py-8">
			<div className="pageTitle">
				<h1>Reset Password</h1>
				<p>Setup a new and secure password.</p>
			</div>

			<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
				{({ values, handleChange, handleSubmit, errors }) => (
					<form onSubmit={handleSubmit}>
						<PasswordInput
							label="Password"
							name="password"
							type="password"
							placeholder="Password"
							value={values.password}
							onChange={handleChange}
							error={errors.password}
							autoComplete="off"
						/>

						<PasswordInput
							label="Confirm Password"
							name="password_confirmation"
							type="password"
							placeholder="Confirm Password"
							value={values.password_confirmation}
							onChange={handleChange}
							error={errors.password_confirmation}
							autoComplete="off"
							className="formItem !tw-w-full"
						/>

						<button type="submit" className="authButton" disabled={isLoading}>
							{isLoading ? "Loading..." : "Continue"}
						</button>

						<p className="authFormText">
							<Link to="/login">Click here to Login</Link>
						</p>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default ResetPassword;
